import { render } from "./mapComponentRGBProduct.vue?vue&type=template&id=4b24d675"
import script from "./mapComponentRGBProduct.vue?vue&type=script&lang=js"
export * from "./mapComponentRGBProduct.vue?vue&type=script&lang=js"

import "./mapComponentRGBProduct.vue?vue&type=style&index=0&id=4b24d675&lang=css"

import exportComponent from "/home/manohar/Bhutan_gitlab/tethysapp-airqualitybt/tethysapp/airqualitybt/vairqualitybt/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__